import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const gameVuex = createNamespacedHelpers("game");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "history",
  computed: {
    ...walletVuex.mapState(["tonConnect"]),
    ...userVuex.mapState(["isLogin", "userInfo"])
  },
  data() {
    const tabList = [{
      label: "Earnings",
      value: 0
    }, {
      label: "Completed Events",
      value: 1
    }];
    return {
      tabList,
      selectTab: null,
      transactionList: null,
      CompletedEventsList: null,
      listPage: {
        total: 0,
        page: 0,
        perPage: 100
      },
      isLoading: false,
      isFinished: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          // await this.initFn();
          window.addEventListener("scroll", this.handleScroll.bind(this));
        }
      },
      deep: true,
      immediate: true
    },
    selectTab(newVal, oldVal) {
      this.getListInfoFunc(false);
    }
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleScroll);
    setTimeout(() => {
      next();
    }, 100);
  },
  methods: {
    ...userVuex.mapActions(["getTransactionList", "getPartyActivityList"]),
    ...gameVuex.mapActions(["getPartyActivityList"]),
    doConnect() {
      if (!this.tonConnect) {
        this.tonWallet.connectTon();
      }
    },
    async initFn(params) {
      if (this.selectTab) {
        if (this.selectTab.value == 0) {
          const transactionInfo = await this.getTransactionList(params);
          return transactionInfo;
        } else if (this.selectTab.value == 1) {
          const partyActivityInfo = await this.getPartyActivityList({
            status: 1,
            ...params
          });
          return partyActivityInfo;
        }
      }
    },
    async getListInfoFunc(isPage) {
      this.listPage.page++;
      if (!isPage) {
        if (this.selectTab.value == 0) {
          this.transactionList = [];
        } else if (this.selectTab.value == 1) {
          this.CompletedEventsList = [];
        }
        this.listPage.page = 1;
      }
      const params = {
        page: this.listPage.page,
        perPage: this.listPage.perPage
      };
      this.isLoading = true;
      const res = await this.initFn(params);
      if (!res) {
        this.isLoading = false;
        return;
      }
      this.listPage.total = res.total;
      console.log("this.selectTab", this.selectTab);
      if (this.selectTab.value == 0) {
        this.transactionList.push(...res.items);
        this.isFinished = this.transactionList.length >= this.listPage.total; // 没有更多数据
      } else if (this.selectTab.value == 1) {
        this.CompletedEventsList.push(...res.items);
        this.isFinished = this.CompletedEventsList.length >= this.listPage.total; // 没有更多数据
      }

      this.isLoading = false;
    },
    async handleScroll() {
      if (this.isLoading || this.isFinished) return;
      // 获取页面滚动的距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 判断是否接近页面底部（距离底部100px以内时触发加载更多）
      if (scrollTop + windowHeight + 1 >= documentHeight) {
        await this.getListInfoFunc(true);
      }
    }
  }
};